import * as React from 'react';
import { createComponent } from '@workday/canvas-kit-react/common';
import { Text } from './Text';
import { inputColors } from '@workday/canvas-kit-react/tokens';
/**
 * This component is intended to be used for labeling input fields. It's built on top of the
 * {@link Text} component, so it has access to all `TextProps`. By default, it renders a semantic
 * `label` element.
 *
 * It also uses the `subtext.large` typeLevel by default:
 * - font-size: 14px (0.875rem)
 * - font-weight: regular (400)
 *
 * ```tsx
 * import { LabelText } from '@workday/canvas-kit-react/text';
 *
 * const CustomLabelText = () => (
 *   <LabelText>Input Label Text</LabelText>
 * );
 * ```
 */
export const LabelText = createComponent('label')({
    displayName: 'Label',
    Component: ({ cursor, disabled, variant, ...elemProps }, ref, Element) => {
        return (React.createElement(Text, Object.assign({ ref: ref, as: Element, typeLevel: "subtext.large", color: disabled && variant !== 'inverse' ? inputColors.disabled.text : undefined, cursor: cursor && !disabled ? cursor : 'default', opacity: disabled && variant === 'inverse' ? '.4' : '1', variant: variant }, elemProps)));
    },
});
